import React from 'react'
//eslint-disable-next-line no-unused-vars
import { Route } from 'react-router-dom'
import HomePage from './pages/home-page'
import AnnouncementPage from './pages/announcement-page'
import GamePage from './pages/game-page'
//import GameElasticMaxBetPage from './pages/game-elastic-max-bet-page';
import MemberListPage from './pages/member-list-page'
import MemberSearchPage from './pages/member-search-page'
import MemberLoginHistoryPage from './pages/member-login-history-page'
import OperationOverviewPage from './pages/operation-overview-page'
import GameReportPage from './pages/game-report-page'
import SettlementReportPage from './pages/settlement-report-page'
import GameRoundResultPage from './pages/game-round-result-page'
import BetGameRoundResultPage from './pages/bet-game-round-result-page'
import FinanceReconciliationPage from './pages/finance-reconciliation-page'
import MarqueePage from './pages/marquee-page'
import UserPage from './pages/user-page'
import RolePage from './pages/role-page'
import PlatformPage from './pages/platform-page'
import EventManagementPage from './pages/event-management-page'
import EventPrizePage from './pages/event-prize-page'
import TransferRecordPage from './pages/transfer-record-page/'

import DefaultRtpSettingPage from './pages/risk-manager/default-rtp-setting-page'
import WaterPoolPage from './pages/risk-manager/water-pool-page'
import ManualPrizePage from './pages/risk-manager/manual-prize-page'
import PlayerRoleListPage from './pages/risk-manager/player-role-list-page'
import RiskRuleSettingPage from './pages/risk-manager/risk-rule-setting-page'
import ContinuousLossSettingPage from './pages/risk-manager/continuous-loss-setting-page'
import RiskmgtLogPage from './pages/risk-manager/riskmgt-log-page'

import EngineManagementPage from './pages/zio/engine-management-page'
import CmsManagementPage from './pages/zio/cms-management-page'
// import BotReportPage from './pages/zio/bot-report-page';
// import JackpotPage from './pages/zio/jackpot-page';
import OnlinePlayerPage from './pages/online-player-page'
import GameRankingList from './pages/game-ranking-list'
import NewGameRecommendPage from './pages/new-game-recommend-page'
import PopularGameRecommendPage from './pages/popular-game-recommend-page'

import ActivityImageManagePage from './pages/activity-image-manage-page'
import {
    Home,
    Announcement,
    ShortText,
    Settings,
    Search,
    Person,
    VideogameAsset,
    AttachMoney,
    InsertChart,
    People,
    MoreHoriz,
    SpeakerNotesOutlined,
    AccountBalanceOutlined,
    SupervisorAccountOutlined,
    SettingsOutlined,
    FolderSharedOutlined,
    Pool,
    MultilineChart,
    Business,
    History,
    RowingOutlined,
    CloudDone,
    Assignment,
    LocalAtm,
} from '@material-ui/icons'

import { MegaphoneFill } from 'react-bootstrap-icons'

import * as utils from '@utils'

export const routeConfig = {
    home: {
        icon: <MoreHoriz />,
        childNode: [
            {
                id: 'home',
                path: '/',
                icon: <Home />,
                component: HomePage,
                componentName: 'HomePage',
            },
        ],
    },
    eventManage: {
        icon: <SpeakerNotesOutlined />,
        childNode: [
            {
                id: 'announcement',
                path: '/announcement',
                icon: <Announcement />,
                component: AnnouncementPage,
                componentName: 'AnnouncementPage',
            },
            {
                id: 'marquee',
                path: '/marquee',
                icon: <ShortText />,
                component: MarqueePage,
                componentName: 'MarqueePage',
            },
        ],
    },
    gameManage: {
        icon: <SettingsOutlined />,
        childNode: [
            {
                id: 'game_list',
                path: '/game-list',
                icon: <Settings />,
                component: GamePage,
                componentName: 'GamePage',
            },
            /*{
        id: 'game_elastic_max_bet',
        path: '/game-elastic-max-bet',
        icon: <Settings />,
        component: GameElasticMaxBetPage,
        componentName: 'GameElasticMaxBetPage',
      },*/
        ],
    },
    membershipManage: {
        icon: <FolderSharedOutlined />,
        childNode: [
            {
                id: 'member_list',
                path: '/member-list',
                icon: <Person />,
                component: MemberListPage,
                componentName: 'MemberListPage',
            },
            {
                id: 'member_search',
                path: '/member-search',
                icon: <Search />,
                component: MemberSearchPage,
                componentName: 'MemberSearchPage',
            },
            {
                id: 'member_login_history',
                path: '/member-login-history',
                icon: <History />,
                component: MemberLoginHistoryPage,
                componentName: 'MemberLoginHistoryPage',
            },
        ],
    },
    operationManage: {
        icon: <AccountBalanceOutlined />,
        childNode: [
            {
                id: 'game_report',
                path: '/game-report',
                icon: <VideogameAsset />,
                component: GameReportPage,
                componentName: 'GameReportPage',
            },
            {
                id: 'settlement_report',
                path: '/settlement-report',
                icon: <AttachMoney />,
                component: SettlementReportPage,
                componentName: 'SettlementReportPage',
            },
            {
                id: 'game_round_result',
                path: '/game-round-result',
                icon: <InsertChart />,
                component: GameRoundResultPage,
                componentName: 'GameRoundResultPage',
            },
            {
                id: 'bet_game_round_result',
                path: '/bet-game-round-result',
                icon: <InsertChart />,
                component: BetGameRoundResultPage,
                componentName: 'BetGameRoundResultPage',
            },
            {
                id: 'finance_reconciliation',
                path: '/finance-reconciliation',
                icon: <AttachMoney />,
                component: FinanceReconciliationPage,
                componentName: 'FinanceReconciliationPage',
            },
            {
                id: 'online_player',
                path: '/online-player',
                icon: <InsertChart />,
                component: OnlinePlayerPage,
                componentName: 'OnlinePlayerPage',
            },
            {
                id: 'transfer_record',
                path: '/transfer-record',
                icon: <AttachMoney />,
                component: TransferRecordPage,
                componentName: 'TransferRecordPage',
            },
            {
                id: 'game_ranking_list',
                path: '/game-ranking-list',
                icon: <InsertChart />,
                component: GameRankingList,
                componentName: 'GameRankingList',
            },
        ],
    },
    marketingManage: {
        icon: <MegaphoneFill style={{ width: '20px', height: '20px', paddingLeft: '1px' }} />,
        childNode: [
            {
                id: 'event_management',
                path: '/event-management',
                icon: <Assignment />,
                component: EventManagementPage,
                componentName: 'EventManagementPage',
            },
            {
                id: 'event_prize',
                path: '/event-prize',
                icon: <LocalAtm />,
                component: EventPrizePage,
                componentName: 'EventPrizePage',
            },
            {
                id: 'new_game_recommend_page',
                path: '/new-game-recommend-page',
                icon: <LocalAtm />,
                component: NewGameRecommendPage,
                componentName: 'NewGameRecommendPage',
            },
            {
                id: 'popular_game_recommend_page',
                path: '/popular-game-recommend-page',
                icon: <LocalAtm />,
                component: PopularGameRecommendPage,
                componentName: 'PopularGameRecommendPage',
            },
            {
                id: 'activity_image_manage',
                path: '/activity-image-manage',
                icon: <Assignment />,
                component: ActivityImageManagePage,
                componentName: 'ActivityImageManagePage',
            },
        ],
    },
    cmsSystemManage: {
        icon: <SupervisorAccountOutlined />,
        childNode: [
            {
                id: 'user',
                path: '/user',
                icon: <Person />,
                component: UserPage,
                componentName: 'UserPage',
            },
            {
                id: 'role',
                path: '/role',
                icon: <People />,
                component: RolePage,
                componentName: 'RolePage',
            },
            {
                id: 'platform',
                path: '/platform',
                icon: <Business />,
                component: PlatformPage,
                componentName: 'PlatformPage',
            },
        ],
    },
    internalControlManage: {
        icon: <Business />,
        childNode: [
            {
                id: 'default_rtp_setting',
                path: '/default_rtp_setting',
                icon: <VideogameAsset />,
                component: DefaultRtpSettingPage,
                componentName: 'DefaultRtpSettingPage',
            },
            {
                id: 'water_pool',
                path: '/water_pool',
                icon: <Pool />,
                component: WaterPoolPage,
                componentName: 'WaterPoolPage',
            },
            {
                id: 'manual_prize',
                path: '/manual_prize',
                icon: <AttachMoney />,
                component: ManualPrizePage,
                componentName: 'ManualPrizePage',
            },
            {
                id: 'player_role_list',
                path: '/player_role_list',
                icon: <People />,
                component: PlayerRoleListPage,
                componentName: 'PlayerRoleListPage',
            },
            {
                id: 'risk_rule_setting',
                path: '/risk_rule_setting',
                icon: <Person />,
                component: RiskRuleSettingPage,
                componentName: 'RiskRuleSettingPage',
            },
            {
                id: 'continuous_loss_setting',
                path: '/continuous_loss_setting',
                icon: <MultilineChart />,
                component: ContinuousLossSettingPage,
                componentName: 'ContinuousLossSettingPage',
            },
            {
                id: 'riskmgt_log',
                path: '/riskmgt_log',
                icon: <History />,
                component: RiskmgtLogPage,
                componentName: 'RiskmgtLogPage',
            },
        ],
    },
    zioFunction: {
        icon: <RowingOutlined />,
        childNode: [
            {
                id: 'engine_management',
                path: '/engine_management',
                icon: <CloudDone />,
                component: EngineManagementPage,
                componentName: 'EngineManagementPage',
            },
            {
                id: 'cms_management',
                path: '/cms_management',
                icon: <CloudDone />,
                component: CmsManagementPage,
                componentName: 'CmsManagementPage',
            },
            {
                id: 'operation_overview',
                path: '/operation-overview',
                icon: <MultilineChart />,
                component: OperationOverviewPage,
                componentName: 'OperationOverviewPage',
            },
        ],
    },
}

export default function CustomRoute(_props) {
    return Object.keys(routeConfig).map((routeGroupID, _idx) =>
        routeConfig[routeGroupID].childNode.map((route, i) => {
            if (utils.checkValid(route.id + '.view') || route.id === 'home') {
                return <Route exact path={route.path} key={i} component={route.component} />
            }

            return null
        })
    )
}
